import React, {useContext} from 'react';
import {makeStyles} from "@material-ui/styles";
import Link from "next/link";
import {useTranslation} from 'tools/i18n';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import theme from "../theme";
import {Container} from "@material-ui/core";
import {TrackingContext} from "../providers/tracking";

const useStyles = makeStyles(theme => ({
	breadcrumbs__wrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
        'div:not(:last-child) > &:after': {
            content: '"›"',
            margin: '0 10px',
            display: 'inline-block'
        },
	},
	breadcrumbs__list: {
		display: 'flex',
		flexWrap: 'no-wrap',
		alignItems: 'center',
		flexDirection: 'flex-start',
		width: '100%',
		padding: 0,
		margin: 0,
		listStyle: 'none',
        whiteSpace: 'nowrap',
	},
	breadcrumbs__item: {
		'& a': {
			color: 'inherit',
            lineHeight: 1,
            textDecoration: 'none',
            fontWeight: 400,
		},
		'&.active': {
			'& a': {
                fontWeight: 400,
			},
		},
		'&:not(:last-of-type):after': {
			content: '"›"',
			margin: '0 10px',
		},
		'&:last-of-type a': {
			textDecoration: 'none',
		},
		'&.product': {
			'& a': {
				color: '#000',
				[theme.breakpoints.up('md')]: {
					fontSize: '14px !important'
				}
			},

            '&:not(:last-of-type):after': {
                content: '"›"',
                margin: '0 10px',
            },
            '&:last-of-type:after': {
                display: 'none',
            },
		}
	}
}));

export default function Breadcrumbs({breadcrumbs = {}, product = false, noGutters = false, className = ''}) {
	const classes = useStyles();
	const isFullwidth = useMediaQuery(theme.breakpoints.up('lg'));
	const {actions: trackingActions} = useContext(TrackingContext);
	const {t} = useTranslation('general');

	if (!breadcrumbs) {
		return null;
	}

	return (
		Object.keys(breadcrumbs).length > 0 ? <Container disableGutters={isFullwidth || noGutters} className={className}>
			<div className={classes.breadcrumbs__wrapper}>
				<ul className={classes.breadcrumbs__list}>
					<li className={[classes.breadcrumbs__item, product ? 'product' : ''].join(' ')} style={{display: 'none'}}>
						<Link href="/">
							{t('home')}
						</Link>
					</li>
					{breadcrumbs ? Object.keys(breadcrumbs).map((key, index) => (
						<li className={[classes.breadcrumbs__item, !product && index + 1 == Object.keys(breadcrumbs).length ? 'active' : '', product ? 'product' : ''].join(' ')} key={index}>
							<Link href={breadcrumbs[key].path}>
								<a onClick={() => trackingActions.click({type: product ? 'product_breadcrumbs_link' : 'category_breadcrumbs_link', text: breadcrumbs[key].name, identifier: breadcrumbs[key].path})}>
									{breadcrumbs[key].name}
								</a>
							</Link>
						</li>
					)) : ''}
				</ul>
			</div>
		</Container> : ''
	);
}
